import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Col, Row } from 'shards-react';

import { useBulkReparseJob } from '../../../hooks/queries/useBulkReparseJob';
import BulkReparseJobSummary from './BulkReparseJobSummary';

const BulkReparseJobStatus = ({ jobId }) => {
  const { job, loading, error } = useBulkReparseJob(jobId);

  if (error) {
    return (
      <Row>
        <Col>
          <Alert theme="danger">No se pudo cargar el estado de la tarea.</Alert>
        </Col>
      </Row>
    );
  }

  if (loading || !job) return null;

  return (
    <Row>
      <Col>
        <BulkReparseJobSummary job={job} />
      </Col>
    </Row>
  );
};

BulkReparseJobStatus.propTypes = {
  jobId: PropTypes.string
};

export default BulkReparseJobStatus;
